import React, { useState } from 'react';
import get from 'lodash/get';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { Col, Row, Form, Input, Button, Spin } from 'antd';
import { DASHBOARD, SIGNUP, FORGOT_PASSWORD } from '../../constants/routes';
import { login } from '../../redux/actions/authActions';
import LoginImage from '../../assets/common/login.png';

function LoginScreen() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) =>
    get(state, 'auth.isLoggedIn', false)
  );

  if (isLoggedIn) {
    return <Redirect to={DASHBOARD} />;
  }

  const onFinish = (values) => {
    setLoading(true);
    dispatch(login({ action: 'login', ...values }))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onFinishFailed = () => {};

  return (
    <Spin spinning={loading}>
      <Row>
        <Col span={16} style={{ textAlign: 'center' }}>
          <img src={LoginImage} alt="" />
        </Col>
        <Col span={8}>
          <div className="login-container">
            <div className="heading">Log In</div>
            <div className="login-form">
              <Form
                name="basic"
                layout="vertical"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                requiredMark={false}
              >
                <div className="mt-20">
                  <Form.Item
                    label="Email id "
                    name="email"
                    className="form-item"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your registered email!',
                      },
                      {
                        type: 'email',
                        message: 'Please Input valid email',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Email or mobile no." />
                  </Form.Item>
                </div>

                <div className="mt-40">
                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your password!',
                      },
                    ]}
                  >
                    <Input.Password placeholder="Enter your password" />
                  </Form.Item>
                </div>

                <Button
                  type="link"
                  block
                  className="forgot-password"
                  onClick={() => {
                    history.push(FORGOT_PASSWORD);
                  }}
                >
                  Forgot Password?{' '}
                  <span className="clickhere"> Click here</span>
                </Button>

                <div className="mt-20">
                  <Form.Item>
                    <Button type="primary" block htmlType="submit">
                      Log in
                    </Button>
                  </Form.Item>
                </div>

                <Button
                  type="link"
                  block
                  className="forgot-password"
                  onClick={() => {
                    history.push(SIGNUP);
                  }}
                >
                  {`Don't you have an account?`}
                  <span className="clickhere"> Register here</span>
                </Button>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </Spin>
  );
}

export default LoginScreen;
